module.exports = __webpack_public_path__ + "img/ahly.eec930ea.png";